import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ToggleSwitch from "@client.components/ToggleSwitch";

const CalculationsSection = ({ 
  isCostIndexPresentation, 
  onUpdateCostIndexPresentation 
}) => {
  const { t } = useTranslation();

  return (
    <div className="settings-section">
      <span>{t("components.Settings.InsightsSettings.calculations")}</span>
      <ToggleSwitch
        value={isCostIndexPresentation}
        onChange={onUpdateCostIndexPresentation}
        labels={[
          t("components.Settings.InsightsSettings.investmentScore"),
          t("components.Settings.InsightsSettings.calculatedAmountUsd"),
        ]}
      />
    </div>
  );
};

CalculationsSection.propTypes = {
  isCostIndexPresentation: PropTypes.bool.isRequired,
  onUpdateCostIndexPresentation: PropTypes.func.isRequired,
};

export default CalculationsSection;
